import { render, staticRenderFns } from "./GroupMetrics.vue?vue&type=template&id=058c1ccc&scoped=true&"
import script from "./GroupMetrics.vue?vue&type=script&lang=ts&"
export * from "./GroupMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMetrics.vue?vue&type=style&index=0&id=058c1ccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.3_vue-template-compiler@2.7.15_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c1ccc",
  null
  
)

export default component.exports